export const convertToValidJSON = text => {
  try {
    // Step 1: Remove any leading/trailing whitespace
    let cleanText = text.trim();

    // Step 2: Handle common formatting issues
    // Remove any BOM characters
    cleanText = cleanText.replace(/^\uFEFF/, '');

    // Remove any non-standard quotes
    cleanText = cleanText
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"');

    // Handle trailing commas (common syntax error in JSON)
    cleanText = cleanText.replace(/,(\s*[}\]])/g, '$1');

    // Step 3: Try to parse the JSON
    const parsedJSON = JSON.parse(cleanText);
    return parsedJSON;
  } catch (error) {
    // If parsing fails, try to fix common issues
    try {
      // Add missing quotes around property names
      let fixedText = text.replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:/g, '"$2":');

      // Fix single quotes to double quotes
      fixedText = fixedText.replace(/'/g, '"');

      return JSON.parse(fixedText);
    } catch (finalError) {
      console.error('Failed to parse JSON:', finalError);
      throw new Error('Invalid JSON format');
    }
  }
};
